import { provideDataClass } from "scrivito"

import { pisaConfig } from "../pisaClient"

export const GDPR = provideDataClass(
  "GDPR",
  (async () => {
    const restApi = await pisaConfig("gdpr")

    if (!restApi) {
      return { connection: {} }
    }

    return { restApi }
  })()
)
